import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {NgIf} from "@angular/common";
import {MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService} from "@azure/msal-angular";
import {EndSessionRequest, EventMessage, EventType, RedirectRequest} from "@azure/msal-browser";
import {environment} from "../../environments/environment";
import {AccountInfo} from "@azure/msal-common";
import {CandidateProfileService} from "../service/candidate-profile.service";
import {filter, ReplaySubject, takeUntil} from "rxjs";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {

  activeAccount: AccountInfo;
  destroy: ReplaySubject<void> = new ReplaySubject<void>(1);

  constructor(private msalService: MsalService,
              @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
              private candidateProfileService: CandidateProfileService) {
    this.msalService.handleRedirectObservable().subscribe();
    this.candidateProfileService.isUnauthorized.pipe(takeUntil(this.destroy),
      filter((result: boolean) => result)).subscribe(() => this.reLogin());
  }

  ngOnInit(): void {
    this.activeAccount = this.msalService.instance.getAllAccounts()[0];

    this.msalService.instance.addEventCallback((event: EventMessage) => {
      if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        const error = event.error;
        if (error && error.name === 'InteractionRequiredAuthError') {
          this.reLogin();
        }
      }
    });
  }

  reLogin() {
     if (this.msalGuardConfig.authRequest){
       this.msalService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
     } else {
       this.msalService.loginRedirect();
     }
  }


  logout() {
    let logoutRequest:EndSessionRequest = {
      account: this.activeAccount,
      authority: environment.msalConfig.auth.authority
    };

    this.msalService.logout(logoutRequest);
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }



}
